import { render, staticRenderFns } from "./LotsList.vue?vue&type=template&id=0632153c&scoped=true"
import script from "./LotsList.vue?vue&type=script&lang=js"
export * from "./LotsList.vue?vue&type=script&lang=js"
import style0 from "./LotsList.vue?vue&type=style&index=0&id=0632153c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0632153c",
  null
  
)

export default component.exports